import { render } from "./App.vue?vue&type=template&id=590419cb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=590419cb&lang=css"

import exportComponent from "/Users/wangwangxinkai/Documents/PBM/tianke-1/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__